
import { getMetaDataConfig } from "../../../../../services/uiConfigService";
import { setEntites } from "../../../../../stateManagement/actions/manageCouponActions";
import store from "../../../../../stateManagement/store";
import { changeALLTONULL, createFilters, createOptionsWithLabel, generatePermutations, getEntityPriority, removeDuplicates, sortHeaderListBasedOnPriority } from "../../../services/services";
import { CouponfilterType } from "../../../types";
import { ALL, ALL_COLUMNS_OF_PRODUCT_SLAB_ALL, COUPON_TYPE_OPTIONS_VALUE, INVALID_ALL_COLUMN_ALL_IN_ILC, INVALID_BATCHCODE_OVERLAPPING, MetaData, VALID, removeEntites } from "../../../utils/utils";


/**
 * This function get the product selection tabs header list
 * @returns get entites from config
 */

export async function getEntities(): Promise<Array<string>> {
    try {
        const res = await getMetaDataConfig("schemeIdentifier-1", "Product");
        if (!res) throw new Error("no response from meta");
        const data = res?.domainValues?.[0]?.columnNames ?? []
        return data;
        // return ["brand" , "pieceSize", 'pieceSizeDesc',"batchCode"]
    } catch (err) {
        console.error(err);
        return [];
    }
}


/**
 * This function return the tabs header in order of priority(high to low) for sku product selection
 * if headers are found in redux config data if return that else make api call
 * to get the data
 * @returns 
 */
export async function getHeadersList(): Promise<Array<string>> {
    const { entities } = store.getState()?.manageCoupons?.configData;

    if (!entities || entities.length === 0) {
        const list = await getEntities();
        const filteredHeaderList = list.filter((header) => MetaData.removeEntites.indexOf(header) < 0);
        const sorted = sortHeaderListBasedOnPriority(filteredHeaderList);
        setEntites(sorted);
        return sorted;
    } else return entities
}

/**
 * check if schemeProductBifurcationsList in redux is empty or not
 * @returns 
 */
export function isSchemeProductBifurcationsListEmpty() {
    const { schemeProductBifurcationsList } = store.getState().manageCoupons?.data
    return schemeProductBifurcationsList.length === 0;
}

/**
 * this function will generate filters based on current values selected
 * @param currentSelectedValues { key : [values]}
 * @param entityName current entityname(headerName) for which we want data
 * @returns 
 */

export async function generateFilters(currentSelectedValues:Record<string,string[] | null>,entityName:string){
    // generating filters
    const filters: CouponfilterType[] = [];

    // priority of current enitity
    const entitiyPri = getEntityPriority(entityName);
    const headersList: string[] = await getHeadersList();
   
    headersList.forEach((header) => {
        const headerPri = getEntityPriority(header);
        const val = currentSelectedValues?.[header];
        // if value selected is not null and its priority is higher(not numerically) then it should be part of filter
        if (val && val!==undefined && Array.isArray(val) &&val.length > 0 && headerPri < entitiyPri) {
            filters.push({ 
                    filterEntity: header,
                    data: header==="batchCode" ? [...val.map((code:string)=>getBatchCodeFromBatchCodeSkuDescriptionString(code))  ] :val, 
                    priority: headerPri 
                })
        }
    })

    // sort filter based on priority so that they can be applied in priority order
    filters.sort((a, b) => a.priority - b.priority)
    return filters;
}



/**
 * 
 * @param currentSelectedValues the selected values will act as filter
 * @param entityName current entity fro which data needs to be fetched
 * @returns unique filtered values of data 
 */

export async function getUniqueValuesfromAllProducts(currentSelectedValues: Record<string,string[]|null>, entityName: string) {
    const { ALL_PRODUCTS } = store.getState().manageCoupons?.configData;
    
    const filters = await generateFilters(currentSelectedValues,entityName);    
    // there is no filter being applied on current entity
    if (filters.length === 0) {
        const ans = createOptionsWithLabel(entityName,ALL_PRODUCTS);
        return removeDuplicates(ans);
    }

    const products = getFilteredProducts(filters, entityName,ALL_PRODUCTS);
    const finalList = createOptionsWithLabel(entityName,products);
    return removeDuplicates(finalList);
}


/**
 * This function return the entity which needs to be concatenated with to create the label
 * @param entityName 
 * @returns 
 */

export function getExtraEntityToAddToLabel(entityName:string){
    if(entityName === "batchCode"){
        return "skuDescription";
    }else{
        return null;
    }
}


/**
 * This function get the products which passes the given filters
 * @param filters 
 * @param entityName entityName is used to compare the products
 * @param products list of products from where products are filters
 * @returns 
 */
export function getFilteredProducts(filters: CouponfilterType[], entityName: string,products:any[]) {
    let finalProducts = [...products];

    filters.forEach(({ filterEntity, data }: { filterEntity: string, data: any }) => {
        const listOfDataForEachFilterValue: Array<Array<any>> = [];
        data.forEach((item: string) => {
            const listOfProduct = finalProducts.filter((pro: any) => pro[filterEntity] === item);
            listOfDataForEachFilterValue.push(listOfProduct);
        })

        const intersectFun = (product1: any, product2: any) => {
            return product1[entityName] === product2[entityName];
        }
   
        // const result = intersectionWithCondition(listOfDataForEachFilterValue, intersectFun);
        const result = listOfDataForEachFilterValue.reduce((total , curr , index)=>{
            return [...total,...curr]
        },[])
        finalProducts = [...result];
    })
    return finalProducts;
}


 
/**
 * Intersection of arrays with given condition
 * @param arrays list of arrays you want to apply intersection on
 * @param condition condition on which intersection should be made
 * @returns 
 */

function intersectionWithCondition(arrays: Array<Array<any>>, condition: (product1: any, product2: any) => boolean) {
    if (arrays.length === 0) {
        return [];
    }

    // Use the first array as the initial set of products
    let result = arrays[0];

    // Iterate through the rest of the arrays
    for (let i = 1; i < arrays.length; i++) {
        const currentArray = arrays[i];

        // Filter the result array based on the "condition" 
        result = result.filter((product1: any) =>
            currentArray.some((product2: any) => condition(product1, product2))
        );
    }

    return result;
}


/**
 * This function is parent function which 
 * validate the product selected in product selection
 * @param data 
 * @returns 
 */
export const validateSchemeProductBifurcationsList = async (currentSelectedValues: Record<string, any>,tabsList:string[]): Promise<string> => {
    const { schemeProductBifurcationsList , couponTypeOption } = store.getState().manageCoupons?.data;
    
    const res1 = ALLColumsALLVAlidation(currentSelectedValues , schemeProductBifurcationsList , tabsList,couponTypeOption);
    if(res1 !== VALID) return res1;
    
    const res2 = overlappingBatchCodesSKUGroupValidation(currentSelectedValues,tabsList);
    if(res2 !== VALID) return res2;

    
    return VALID;

}

export const ALLColumsALLVAlidation = (currentSelectedValues:Record<string, any> ,alreadyPresentValues:Record<string, string | string[]>[],tabsList:string[] ,couponTypeOption?:string)=>{
    let allColumsAll = true;
    tabsList.forEach((tab)=>{
        if(currentSelectedValues[tab].length > 0) allColumsAll = false;
    })

   if(allColumsAll && ( couponTypeOption === COUPON_TYPE_OPTIONS_VALUE.BUNDLE || couponTypeOption === COUPON_TYPE_OPTIONS_VALUE.BUNDLE_PLUS_TOTAL_ORDER_VALUE || couponTypeOption ===  COUPON_TYPE_OPTIONS_VALUE.ITEM_LEVEL_COUPON) ){
        return INVALID_ALL_COLUMN_ALL_IN_ILC;
   }


    if (allColumsAll && alreadyPresentValues.length > 0) {
        return ALL_COLUMNS_OF_PRODUCT_SLAB_ALL;
    }

    return VALID;
}

const overlappingBatchCodesSKUGroupValidation = (currentData:Record<string, any>,tabsList:string[])=>{
    const { schemeProductBifurcationsList } = store.getState().manageCoupons?.data;
    return overlappingBatchCodes(currentData , tabsList , schemeProductBifurcationsList)
}

export const overlappingBatchCodes = (currentData:Record<string, string[] | string | null> , tabsList:string[] , listOfAlreadySelectedData:Record<string, string | string[]>[])=>{
    const {ALL_PRODUCTS} = store.getState()?.manageCoupons?.configData;    
    const currentDataFilters = createFilters(currentData , tabsList);
    const batchCodesForCurrentData = getProducts(ALL_PRODUCTS,currentDataFilters).map((item:any)=>item.batchCode);
    
    let alreadyPresentBatchCodes:string[] = [];

    for(let i=0 ; i<listOfAlreadySelectedData.length ; i++){
        if(listOfAlreadySelectedData[i]?.id !== currentData?.id){
            const filters:Record<string,string[]> = createFilters(listOfAlreadySelectedData[i],tabsList);
            alreadyPresentBatchCodes = [...alreadyPresentBatchCodes ,  ...getProducts(ALL_PRODUCTS,filters).map((item:any)=>item.batchCode)];    
        }
       }

    for(let i=0 ; i<batchCodesForCurrentData?.length; i++){
        const curr = batchCodesForCurrentData[i];
        if(alreadyPresentBatchCodes.includes(curr)){
            return INVALID_BATCHCODE_OVERLAPPING;
        }
    }

    return VALID;
    
}


/**
 * get single row data from schemeProductBifurcationsList. and it will change ALL value to null
 * @param index 
 * @returns 
 */
export function getRowData(index: number): object {
    const { schemeProductBifurcationsList } = store.getState()?.manageCoupons?.data;
    const data: Record<string, any> = schemeProductBifurcationsList[index];
    return changeALLTONULL(data);
}

/**
 * Create rows(2D array) in the order of header priority
 * used to generate table
 * @param data 
 * @returns 
 */
export const generateRowsSchemeProductBifurcationsList = async (data: Record<string,string|string[]>[]): Promise<Array<Array<string>>> => {
    const headersList = await getHeadersList();

    const rows: Array<Array<string>> = data.map((item: Record<string, string[]|string>) => {
        const row: Array<string> = [];
        headersList.forEach((header: string) => {
            const selectedValues = item?.[header];
            if (selectedValues && selectedValues?.length === 0) row.push(ALL);
            else if(selectedValues && Array.isArray(selectedValues)){
                let str = selectedValues[0];
                selectedValues.slice(1).forEach((val: string) => {
                    str += '*break*' + val;
                })
                row.push(str);
            }
        })
        return row;
    })
    return rows;
}



/**
 * we are strong batchCode in redux by concatenating it with sku description (batchCode + skuDescription)
 * this function will will get the batchCode from that string
 * @param data 
 * @returns 
 */
export const getBatchCodeFromBatchCodeSkuDescriptionString =(data: string):string=>{
    return data.split(" (")[0];
}

export const getValueFromValueConcatenatedLabel=(label:string,entityName:string):string=>{
    if(entityName === 'batchCode') return getBatchCodeFromBatchCodeSkuDescriptionString(label);
    else return label
}

/**
 * get all the products from the given products that passes the filter
 * @param products 
 * @param filters entityName : [... , selected Values]
 * @returns 
 */
export const getProducts = (products:any[],filters:Record<string,string[]>)=>{
    const ans:any[] = [];
    products.forEach((product)=>{
        if(isProductPassingFilter(product,filters)){
            ans.push(product);
        }
    })
    return ans;
}


/**
 * checking if product passes the filter
 * @param product 
 * @param filters 
 * @returns 
 */
const isProductPassingFilter =(product:any,filters:Record<string,string[]>)=>{
    let ans = true;
    for(let prop in filters){
        const canHaveValues = filters[prop];
        const value = product[prop];
        ans = ans && canHaveValues.includes(value);
    }
    return ans;
}


export const filterSelectedProductGroup = async(currentSelectedValues: Record<string, any>,tabsList:string[])=>{
    const sortedHeaderList = sortHeaderListBasedOnPriority(tabsList);
    const arr:Array<Array<string>>=[];
    const usedHeaderList:string[] = [];
    
    sortedHeaderList.forEach((header:string)=>{
        if(currentSelectedValues[header] && currentSelectedValues[header].length > 0){
            arr.push(currentSelectedValues[header]);
            usedHeaderList.push(header);
        }
    })

    const perm = generatePermutations(arr);
    const validPerm : Array<Array<string | number>>= [];
    // const productSeachSet = getProductSearchSet(usedHeaderList);

    for(let i=0 ; i<perm.length ; i++){
        const per = perm[i];
        const features:Record<string , any> = {};
        
        per.forEach((val,index)=>{
            features[usedHeaderList[index]] = val;
        })

        if(doesProductExist(features)){
            validPerm.push(per);
        }
    }
    
    const validSkuGrp: Record<string,any> = {}

    validPerm.forEach((per)=>{
        per.forEach((val,index)=>{
            const header = usedHeaderList[index];
            if( !validSkuGrp[header] || validSkuGrp[header] === undefined){
                validSkuGrp[header] = [val];
            }else{
                if(!validSkuGrp[header].includes(val))
                    validSkuGrp[header] = [...validSkuGrp[header] , val]
            }
        })
    })

    // adding empty values headers
    sortedHeaderList.forEach((header:string)=>{
        if(!validSkuGrp[header] || validSkuGrp[header]===undefined){
            validSkuGrp[header] = [];
        }
    })

    return validSkuGrp;

}

// export const doesProductExist=(features:Record<string,string> , productSearchSet:Set<string>)=>{
//     const key = getProductKey(features , Object.keys(features));
//     return productSearchSet.has(key);
// }
export const doesProductExist=(features:Record<string,string>)=>{
    const {ALL_PRODUCTS}  = store.getState()?.manageCoupons?.configData;
    return ALL_PRODUCTS.some((product:any)=>{
        let validProduct = true;
        Object.keys(features).forEach((header:string)=>{
            if(product.hasOwnProperty(header)){
                const val = getValueFromValueConcatenatedLabel(features[header],header);
                validProduct = validProduct && product[header] === val;
            }
        })
        return validProduct;
    })
}

export function getProductSearchSet(headersList:string[]){
    const {ALL_PRODUCTS}  = store.getState()?.manageCoupons?.configData;
    const newStringList = [];
    
    for(let i=0 ; i<ALL_PRODUCTS.length ; i++){
        const product = ALL_PRODUCTS[i];
        const key = getProductKey(product,headersList);
        newStringList.push(key);
    }
    return new Set(newStringList);
}


export function getProductKey(product:any , headersList:string[]) {
    let finalStr="";
    headersList.forEach((header:string)=>{
        const val = getValueFromValueConcatenatedLabel(product[header],header);
        finalStr += `${val}===`
    })
    return finalStr.substring(0,finalStr.length - 3);
}